<template>
  <ul v-if="menus" id="mega-menu-main-navigation-1" class="alt-header-menu-primary" data-effect="fade_up" >
    <li v-for="(menu, menu_id) in menus" :key="menu.id" class="alt-menu-item alt-mega-menu-item alt-has-submenu" :id="'alt-menu-item-' + menu.id" :class="menu.classes ? menu.classes : ''">
      <CustomLink
        v-if="menu.title || menu.url"
        class="alt-menu-link"
        :url="getLangUrl(menu.url, baseUrl, locale)"
        :style="menu.bg_sale_campaign ?? ''"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <span v-if="menu.image_menu" v-html="lazyMenuImages(menu.image_menu)" class="cs_icon_menu"></span>
        <img loading="lazy" decoding="async" v-if="menu.classes == 'alt-img'" :src="menu.bg_sale_campaign ?? ''" class="img_cs_menu" :alt="menu?.alt ?? ''">
        <span v-else>{{ menu.title }}</span>
        <span v-if="menu.children" class="alt-menu-indicator"></span>
      </CustomLink>
      <ul v-if="menu.children" v-show="showMenu" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave" class="dev6 alt-sub-megamenu alt-submenu alt-menu-layout-1 layout_default">
        <li v-for="(children, children_key) in menu.children" :key="children_key" :class="['alt-submenu-item', 'alt-menu-col-' + children_key]">
            <CustomLink v-if="children.items" v-for="item in children.items" :key="item.id" :url="getLangUrl(item.url, baseUrl, locale)" :class="{'d-none': !item.url}" @click="handleMenuClick()" class="edev222 alt-menu-link alt-menu-primary-link alt-menu-link-alone">
              <span v-if ="item.image_menu" v-html="lazyMenuImages(item.image_menu)"></span>
              <span v-if ="item.title" class="menu-item-title" v-html="item.title"></span>
              <span v-if ="item.menu_item_tag" v-html="item.menu_item_tag"></span>
              <div v-if="item?.classes?.includes('custom_gold_price')" class="custom_gold_price"> 
                <div class="item_gole_price" v-for="(item, price_key) in data_gold_price" :key="price_key">
                  <p class="key_price">{{ item?.sub_title }}:</p>
                  <p class="value_price"><span :class="`price_gold pt_cs gold_${item?.sub_title}`">{{ displayCustomPrice(item?.rate_value) }}</span><span>/g</span></p>
                </div>
              </div>
            </CustomLink>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import CustomLink from '~/components/CustomLink.vue';
import { lazyMenuImages } from '~/utils/lazyMenuImages';
const runtimeConfig = useRuntimeConfig();
import { displayCustomPrice } from "~/utils/displayPrice";
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';
const baseUrl = runtimeConfig.public.BASE_URL;

const menus = ref();
const userStore = useUserStore();
const { $file } = useNuxtApp();
interface IResponsePost {
  success: boolean;
  data: string;
}
const showMenu = ref(true);
const isClicking = ref(false);
const handleMenuClick = () => {
  isClicking.value = true;
  showMenu.value = false;
  setTimeout(() => {
    isClicking.value = false;
  }, 300);
}
const handleMouseEnter = () => {
  showMenu.value = true;
}
const handleMouseLeave = () => {
  showMenu.value = false;
}

const getHeaderMenu = async () =>  {
  try {
    const { data: header_desktop, error } = await useAsyncData(
      'menuDesktop',
      async () => {
        return $file.get('menu/header-menu.json', {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          },
        });
      }
    )

    const responseMenu = header_desktop.value as IResponsePost;
    if (responseMenu.success && Array.isArray(responseMenu.data)) {
      menus.value = responseMenu.data;
    }
  }catch (error) {
    console.error("Error fetching:", error);
  }
}
const data_gold_price = ref();
const data_gold_999 = ref();
const data_gold_916 = ref();
const getDataGoldPrice = async () => {
    try {
        const response = await $file.get(`${runtimeConfig.public.BASE_URL}api/wp-json/skj/v1/gold-price-table`, {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          },
        });
        
        if(response){
          data_gold_price.value = response?.price_labour;
          // data_gold_916.value = response.price_labour[0]?.rate_value ?? '';
          // data_gold_999.value = response.price_labour[1]?.rate_value ?? '';
  
          // const price_916 = displayCustomPrice(data_gold_916.value);
          // const price_999 = displayCustomPrice(data_gold_999.value);
  
          // const el916 = document.querySelector('.gold_916');
          // const el999 = document.querySelector('.gold_999');
  
          // if (el916 && price_916) el916.textContent = price_916;
          // if (el999 && price_999) el999.textContent = price_999;
        }
        
    } catch (e) {
        console.error("Error fetching recently viewed products:", e);
    }
};
onMounted(async () => {
  setTimeout(() => {
      getDataGoldPrice();
  }, 500)
});
getHeaderMenu();
</script>
<style lang="scss">
    @import '@/assets/scss/components/menu/_header.scss';
</style>

